import React  from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import css from '~/features/dashboard/components/song-details/styles.module.scss';
import {
    Box,
    Button,
    Grid,
} from '@material-ui/core';
import { AutocompleteRenderInputParams } from '@material-ui/lab/Autocomplete/Autocomplete';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextFieldOutlined } from '~/common/text-field-outlined';
import { Controller, useForm } from 'react-hook-form';
import { ArrowRightIcon } from 'material-ui-pickers/_shared/icons/ArrowRightIcon';
import { SongProjectTrack } from '~/models/music/new-song/newSongResponse.dto';
import { EmojiObjectsOutlined } from '@material-ui/icons';

export type TrackReleaseType = {
    isrc: string;
    tips: string;
    whereToPublish: string;
};

interface Props {
    close: (data?: TrackReleaseType) => void;
    projectId: any;
    data: SongProjectTrack;
}

export const TrackReleaseDrawer: React.FC<Props> = ({ close, projectId, data }) => {
    const publishedOptions = [
        'Artist Serve',
    ];

    const { register, control, getValues } = useForm<TrackReleaseType>({
        defaultValues: data,
    });

    const submitBtn = () => {
        close(getValues());
    };

    return (
        <div style={{width: '30vw'}}>
            <input type="hidden" ref={register} name="isrc"/>
            <div>
                <div style={{ borderBottom: '1px solid #ccc', padding: '10px 0px 10px 24px', verticalAlign: 'center' }}>
                    <div
                        className={css.closeBtn}
                        onClick={() => close()}
                    >
                        <ArrowBackIcon style={{ verticalAlign: 'center', lineHeight: '10px', cursor: 'pointer' }} />
                        <Typography variant={'h6'} className={css.drawertitle} style={{ lineHeight: '25px', cursor: 'pointer', marginLeft: '0.5rem' }}>
                            Close
                        </Typography>
                    </div>
                </div>
                <div className={css.header} style={{ padding: '24px' }}>
                    <Typography variant={'h6'} className={css.drawertitle}>
                        My Recoding
                    </Typography>
                </div>
            </div>
            <div className={css.dspCardbox}>
                <Grid container spacing={3} className={css.gridContainer}>
                    <Grid item xs={12}>
                        <Controller
                            defaultValue={data.whereToPublish}
                            render={props => (
                                <Autocomplete
                                    {...props}
                                    options={publishedOptions}
                                    fullWidth
                                    value={props.value}
                                    renderInput={(p: AutocompleteRenderInputParams) => (
                                        <TextFieldOutlined {...p} label="Where to publish?" />
                                    )}
                                    onChange={(_, data) => props.onChange(data)}
                                    // getOptionLabel={(selection) => selection.value}
                                />
                            )}
                            name="whereToPublish"
                            control={control}
                        />
                    </Grid>
                    <Grid item xs={12} className={css.tips}>
                        <Typography variant="subtitle2" className={css.tipsLabel} >Sales Tips <EmojiObjectsOutlined /></Typography>
                        <Box className={css.tipsArea}>
                            <ArrowRightIcon />
                            <TextFieldOutlined
                                name="tips"
                                inputRef={register}
                                multiline
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button className={css.button} variant="contained" color="primary" onClick={submitBtn}>
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};
